import './App.css'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Header from './components/Header'
import NewHome from './pages/NewHome'
import Work from './pages/Work'
import Lab from './pages/Lab'
import Photos from './pages/Photos'
import About from './pages/About'
import Contact from './pages/Contact'
import Blog from './pages/Blog'
import Post from './pages/Post'

function App() {
  return (
    <Router>
      <Header />
      <Switch>
        <Route path='/' exact component={NewHome} />
        <Route path='/new' exact component={NewHome} />
        <Route path='/work' exact component={Work} />
        <Route path='/lab' exact component={Lab} />
        <Route path='/photos' exact component={Photos} />
        <Route path='/about' exact component={About} />
        <Route path='/contact' exact component={Contact} />
        <Route path='/blog' exact component={Blog} />
        <Route path='/post/:slug' component={Post} />
      </Switch>
    </Router>
  )
}

export default App
